import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'

import requests from 'app/requests/Container/DamageType.requests'
import DamageTypeForm from '../DamageTypeForm'

const DamageTypeCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    return (
        <DamageTypeForm
            onSuccess={onSuccess}
            requestParams={requests.create()}
        />
    )
}

export default DamageTypeCreate
